import { HelmetProvider, Helmet } from 'react-helmet-async';
import type { ReactNode } from 'react';

interface PageMetaProps {
  title: string;
  description: string;
}

const PageMeta = ({ title, description }: PageMetaProps) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
  </Helmet>
);

interface AppWrapperProps {
  children: ReactNode;
}

export const AppWrapper = ({ children }: AppWrapperProps) => (
  <HelmetProvider>{children}</HelmetProvider>
);

export default PageMeta;
